export enum TaxReportForm {
    FORM_941 = 'FORM_941',
    FORM_940 = 'FORM_940',
    FORM_1120 = 'FORM_1120',
    FORM_1120S = 'FORM_1120S',
    FORM_1065 = 'FORM_1065',
    SALES_TAX_REPORT = 'SALES_TAX_REPORT',
    ANNUAL_REPORT = 'ANNUAL_REPORT',
    FORM_NYS_45 = 'FORM_NYS_45',
    FORM_RT_6 = 'FORM_RT_6',
    FORM_NJ_927 = 'FORM_NJ_927',
    FORM_WR_30 = 'FORM_WR_30',
    FORM_CT_941 = 'FORM_CT_941',
    FORM_DE_9 = 'FORM_DE_9',
    TAX_BILL = 'TAX_BILL',
}

export function getTaxReportFormLabel(form: TaxReportForm): string {
    switch (form) {
        case TaxReportForm.FORM_941: return "Form 941";
        case TaxReportForm.FORM_940: return "Form 940";
        case TaxReportForm.FORM_1120: return "Form 1120";
        case TaxReportForm.FORM_1120S: return "Form 1120S";
        case TaxReportForm.FORM_1065: return "Form 1065";
        case TaxReportForm.SALES_TAX_REPORT: return "Sales Tax Report";
        case TaxReportForm.ANNUAL_REPORT: return "Annual Report";
        case TaxReportForm.FORM_NYS_45: return "Form NYS-45";
        case TaxReportForm.FORM_RT_6: return "Form RT-6";
        case TaxReportForm.FORM_NJ_927: return "Form NJ-927";
        case TaxReportForm.FORM_WR_30: return "Form WR-30";
        case TaxReportForm.FORM_CT_941: return "Form CT-941";
        case TaxReportForm.FORM_DE_9: return "Form DE-9";
        case TaxReportForm.TAX_BILL: return "Tax Bill";
        default: return form;
    }
}
